<template>
  <v-dialog
    :value="true"
    max-width="290"
    persistent
  >
    <v-card>
      <v-card-title class="text-h5">
        {{ title }}
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col>Редактировать: {{ value }}</v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field
              v-model="newValue"
              :label="text"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          @click="$emit('cancel')"
        >
          Отмена
        </v-btn>
        <v-btn
          color="blue darken-1"
          text
          @click="$emit('ok', newValue)"
        >
          Продолжить
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script >
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    },
    value: {

    }
  },
  data: () => ({
    newValue: "",
  })
}
</script>

<style scoped>

</style>
